export enum Language {
  enGB = 'en-gb',
  enUS = 'en-us',
}
